import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { RedirectToPublicProposal } from './redirect-to-public-proposal';

interface RedirectToPublicProposalWhenPrintingProps {
  children: ReactNode;
}

export const RedirectToPublicProposalWhenPrinting = ({ children }: RedirectToPublicProposalWhenPrintingProps) => {
  const { search } = useLocation();

  if (new URLSearchParams(search).has('print')) return <RedirectToPublicProposal />;

  return <>{children}</>;
};
